import React, { Suspense, useEffect } from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import { LazyLoader } from "Layout/lazy-loader";
import Routes from "Config/routes";
import { isLoggedIn } from "Helpers/auth-helper";
import APP_CONSTANTS from "../constants/app-constants";

function AppRouter() {
  const location = useLocation();
  const params = new URLSearchParams(location?.search);
  const paramToken = params.get('token');
  const paramPage = params.get('page');

  useEffect(() => {
    if (paramToken) {
      try {
        const accessToken = localStorage.getItem(APP_CONSTANTS.ACCESS_TOKEN);

        if (!accessToken) {
          localStorage.setItem(APP_CONSTANTS.ACCESS_TOKEN, JSON.stringify(paramToken));
        }
        else {
          localStorage.removeItem(APP_CONSTANTS.ACCESS_TOKEN);
          localStorage.setItem(APP_CONSTANTS.ACCESS_TOKEN, JSON.stringify(paramToken));
        }
        window.location.reload();
      } catch (e) {
        console.log("An error occurred in auto login", e);
      }
    }
  }, []);

  return (
    <Suspense fallback={<LazyLoader />}>
      <Switch>
        {isLoggedIn()
          ? // ONLY AUTHENTICATED ROUTES AVAILABLE IF LOGGED IN
          Routes.filter((route) => route.requireAuthentication).map(
            (route) => (
              <Route
                key={route.name}
                path={route.path}
                component={route.component}
              />
            )
          )
          : // ONLY NON-AUTHENTICATED ROUTES AVAILABLE IF LOGGED OUT
          Routes.filter((route) => !route.requireAuthentication).map(
            (route) => {
              return (
                <Route
                  key={route.name}
                  path={route.path}
                  component={route.component}
                />
              );
            }
          )}

        <Route path="*">
          {isLoggedIn() ? (
            paramPage ?
              <Redirect to={`/main/${paramPage}`} />
              :
              <Redirect to="/main/dashboard" />
          ) : (
            <Redirect to="/login" />
          )}
        </Route>
      </Switch>
    </Suspense>
  );
}

export default AppRouter;
